import { addUpdatePricing } from '../../../../actions/siteadmin/Pricing/addUpdatePricing';

async function submit(values, dispatch) {
    let isActive = values.isActive == 'true' ? true : false;
    let isSurgePrice = values.isSurgePrice == 'true' ? true : false;
    let surgePricing = JSON.stringify(values.surgePricing);

    await dispatch(
        addUpdatePricing(
            values.id,
            values.locationId,
            values.categoryId,
            values.currency,
            values.basePrice,
            values.unitPrice,
            values.minutePrice,
            values.riderFeeType,
            values.riderFeeValue,
            values.driverFeeType,
            values.driverFeeValue,
            isActive,
            isSurgePrice,
            values.baseFare,
            surgePricing,
            values.waitingPrice
        )
    )
}

export default submit;